module.exports = __webpack_public_path__ + "static/media/republic-of-macedonia.611e09fe.png";